import storeData from 'reduxBase/store';

export const store = storeData.store;
export const persistor = storeData.persistor;
export const history = storeData.history;
